import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormStateService {
  private registrationFormState: any = null;

  saveRegistrationFormState(formState: any): void {
    this.registrationFormState = formState;
  }

  getRegistrationFormState(): any {
    return this.registrationFormState;
  }

  clearRegistrationFormState(): void {
    this.registrationFormState = null;
  }
}